import React from 'react';
import PropTypes from 'prop-types';

export function OdometerWrapperSeo({ value, className }) {
  return <div className={className}>{value}</div>;
}

OdometerWrapperSeo.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
};

OdometerWrapperSeo.defaultProps = {
  className: '',
};
